import { memo, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';

import { LoadingSection } from '@makemydeal/dr-shared-components';
import * as contractingSelectors from '@makemydeal/dr-dash-store/selectors/contractingSelectors';
import type { LoadingIndicatorSize } from '@makemydeal/dr-shared-components';

export interface IPaymentLoadingProps {
    testId: string;
    isLoading?: boolean;
    size?: number | LoadingIndicatorSize;
    opacity?: number;
}

const PaymentLoading = ({ testId, isLoading, size, opacity }: IPaymentLoadingProps) => {
    const isContractValidationLoading = useSelector(contractingSelectors.isContractValidationLoading);
    const spinnerVisibleStartTimeRef = useRef<number | null>(null);

    const loading = isLoading ?? isContractValidationLoading;

    useEffect(() => {
        if (loading && spinnerVisibleStartTimeRef.current === null) {
            spinnerVisibleStartTimeRef.current = Date.now();
            return;
        }

        if (!loading && spinnerVisibleStartTimeRef.current !== null) {
            const durationMs = Date.now() - spinnerVisibleStartTimeRef.current;

            logNewRelicPageAction('MV:Payment - Spinner Duration', {
                durationMs,
                spinnerTestId: testId
            });

            spinnerVisibleStartTimeRef.current = null;
        }
    }, [loading, testId]);

    return <LoadingSection loading={loading} testId={testId} size={size} opacity={opacity ?? 0.3} />;
};

export default memo(PaymentLoading);
